<div class="ac-layermanager">
    <div class="text-right">
        <div ngbDropdown placement="bottom-right" class="d-inline-block" autoClose="true"
            #layerlistDropdown="ngbDropdown">
            <button class="btn btn-outline-primary text-white ac-layerlist-toggle d-flex justify-content-between"
                ngbDropdownToggle [title]="HsLayerUtilsService.translateTitle(visibleLayer.title)">
                <div class="text-truncate">{{HsLayerUtilsService.translateTitle(visibleLayer.title)}}</div>
            </button>
            <div ngbDropdownMenu class="ac-layerlist p-3">
                <div *ngFor="let layer of layers;let i = index" class="mapoverlay-dropdown-item  w-100 flex-column">
                    <layer-list-item class="w-100"
                        (layerVisiblityChanged)="layerSelected($event); layerlistDropdown.close()" [layer]="layer">
                    </layer-list-item>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="ac-opacity-slider">
    <p class="opacity-slider-title">{{this.HsLanguageService.getTranslationIgnoreNonExisting("MAPOVERLAY","opacity")}}
    </p>
    <ngx-slider [(value)]="opacity" [options]="opacitySliderOptions" (userChangeEnd)="setOpacity($event)"></ngx-slider>
</div>